import { ApplicationType } from '@dealstack/shared/lib/generated';
import { createAction, createReducer } from '@reduxjs/toolkit';

export interface GlobalState {
	isLoadingTranslations: boolean;
	applicationType: ApplicationType | undefined;
}

export const loadingTranslationsStart = createAction('global/loadingTranslations/start');
export const loadingTranslationsSuccess = createAction('global/loadingTranslations/success');
export const loadingTranslationsError = createAction<unknown>('global/loadingTranslations/error');
export const setApplicationType = createAction<ApplicationType>('global/applicationType');

const initialState = {
	isLoadingTranslations: true,
	applicationType: undefined,
} as GlobalState;

// https://redux-toolkit.js.org/api/createReducer
export const globalReducer = createReducer(initialState, (builder) => {
	builder
		.addCase(loadingTranslationsStart, (state) => {
			state.isLoadingTranslations = true;
		})
		.addCase(loadingTranslationsSuccess, (state) => {
			state.isLoadingTranslations = false;
		})
		.addCase(loadingTranslationsError, (state) => {
			state.isLoadingTranslations = false;
		})
		.addCase(setApplicationType, (state, action) => {
			state.applicationType = action.payload;
		});
});
